import { createUseStyles } from 'react-jss'

import { bannerGrey, lightGrey, mediumGrey } from '../../../../styles/const/colors'
import { bigBorderRadius } from '../../../../styles/const/common'

export default createUseStyles({
  container: {
    border: `1px solid ${mediumGrey}`,
    borderRadius: bigBorderRadius,
    background: ({ isDark }) => (isDark ? lightGrey : 'white'),

    '&:not(:last-child)': {
      marginBottom: hasMargin => hasMargin && 16
    }
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    borderTopLeftRadius: bigBorderRadius,
    borderTopRightRadius: bigBorderRadius,
    padding: '16px 20px',
    borderBottom: `1px solid ${mediumGrey}`,
    background: ({ isDark }) => (isDark ? bannerGrey : 'white')
  },
  title: {
    fontSize: 16,
    fontWeight: 600
  },
  content: {
    padding: '18px 20px 20px'
  }
})
